import palette from '../theme/palette';

// Line colour per benchmark; never green or coral (reserved for gains/losses).
export const BENCHMARK_COLORS = {
  cac40: palette.chart.series[3],
  eurostoxx50: palette.chart.series[4],
  cw8: palette.chart.series[1],
};

const DEFAULT_COLOR = palette.chart.series[7];

export const benchmarkColor = (id) => BENCHMARK_COLORS[id] || DEFAULT_COLOR;

// Cumulative return (in %) of a benchmark on each portfolio date, rebased on
// the portfolio's first date: each date takes the last close on or before it
// (markets close on different days), the base is the close on or before the
// first date (else the first one after). Dates before any close stay null.
export const rebaseOnDates = (points, dates) => {
  const closes = (points || []).filter((p) => p && Number.isFinite(p.close) && p.close > 0).sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
  if (closes.length === 0 || dates.length === 0) return dates.map(() => null);
  const closeAt = (date) => {
    let found = null;
    for (const p of closes) {
      if (p.date > date) break;
      found = p.close;
    }
    return found;
  };
  const base = closeAt(dates[0]) ?? closes[0].close;
  return dates.map((date) => {
    const close = closeAt(date);
    return close === null ? null : Math.round((close / base - 1) * 10000) / 100;
  });
};

// Last known value of a rebased series (the period return).
export const periodReturn = (values) => {
  for (let i = values.length - 1; i >= 0; i -= 1) if (values[i] !== null && values[i] !== undefined) return values[i];
  return null;
};
